<template>
    <div>
        <el-row class="u-mt-10 u-mb-20" :gutter="10">
            <el-col :xs="24" :sm="4" :md="3">
                <el-input v-model="filtro.id" placeholder="Nº" @keyup.native.enter="load"></el-input>
            </el-col>
            <el-col :xs="24" :sm="9" :md="9">
                <el-input v-model="filtro.aluno_nome" placeholder="Pesquisar aluno..." @keyup.native.enter="load"></el-input>
            </el-col>
            <el-col :xs="24" :sm="3" :md="3">
                <el-input v-model="filtro.ano" placeholder="Ano" @keyup.native.enter="load"></el-input>
            </el-col>
            <el-col :xs="24" :sm="3" :md="3">
                <el-button @click="load" type="primary" plain>FILTRAR</el-button>
            </el-col>
            <el-col :xs="24" :sm="5" :md="6" class="u-text-right">
                <router-link to="/admin/pedagogico/aee/form" class="btn-new-register">
                    <el-button type="primary">NOVO AEE/PAD</el-button>
                </router-link>
            </el-col>
        </el-row>

        <div class="container-table">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th style="width: 70px;">Nº</th>
                        <th>Aluno</th>
                        <th class="hidden-mobile" style="width: 90px;">Ano</th>
                        <th class="hidden-mobile" style="width: 110px;">Data</th>
                        <th class="hidden-mobile" style="width: 120px;">Status</th>
                        <th style="width: 200px;" class="u-text-center">Ação</th>
                    </tr>
                </thead>
                <tbody v-if="statusList">
                    <tr v-for="item in items" :key="item.id">
                        <td>{{ item.id }}</td>
                        <td>{{ item.aluno ? item.aluno.nome : '-' }}</td>
                        <td class="hidden-mobile">{{ item.ano }}</td>
                        <td class="hidden-mobile">{{ formatDate(item.data) }}</td>
                        <td class="hidden-mobile">
                            <span v-if="item.finalizado" style="color: #67c23a;">Finalizado</span>
                            <span v-else style="color: #e6a23c;">Em edição</span>
                        </td>
                        <td class="u-text-center acao">
                            <router-link :to="'/admin/pedagogico/aee/form/' + item.id" class="link-icon u-mr-10" style="color: rgba(0, 0, 0, 0.87) !important;">
                                <el-button type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
                            </router-link>
                            <el-button @click="imprimir(item.id)" title="Imprimir" type="primary" icon="el-icon-printer" size="mini" plain class="u-mr-10"></el-button>
                            <el-button @click="excluir(item.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                        </td>
                    </tr>
                    <tr v-if="!items.length">
                        <td colspan="6" class="u-text-center" style="padding: 20px;">Nenhum AEE/PAD encontrado.</td>
                    </tr>
                </tbody>
            </table>

            <div v-if="!statusList" class="u-text-center u-mt-25">
                <img src="/public/img/loading-bar.gif" />
            </div>

            <el-row :gutter="10" v-if="statusList">
                <el-col :xs="24" :sm="12">
                    <div class="u-text-left u-mt-10">
                        Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros encontrados.
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" v-if="paginate.qtdItens > 30">
                    <div class="u-text-right">
                        <el-pagination :current-page="paginate.page" class="u-mt-10" :total="paginate.qtdItens"
                            @current-change="getPage" :page-size="30" background layout="prev, pager, next" small></el-pagination>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        statusList: false,
        filtro: { id: '', aluno_nome: '', ano: '' },
        paginate: { page: 1, qtdItens: null, from: '', to: '' },
        items: []
    }),
    mounted () { this.load() },
    methods: {
        formatDate (d) {
            if (!d) return '-'
            return this.$moment(d).format('DD/MM/YYYY')
        },
        load () {
            this.statusList = false
            this.items = []
            const filtro = { ...this.filtro }
            const inst = this.$store.state.config && this.$store.state.config.instituicao ? this.$store.state.config.instituicao : null
            if (inst && inst.id) filtro.instituicao_id = inst.id

            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/plano-aee/getAllPaginate?page=` + this.paginate.page,
                filtro,
                this.$store.getters.getHeaderAuth
            ).then(response => {
                this.items = response.data.data
                this.paginate.qtdItens = response.data.total
                this.paginate.from = response.data.from
                this.paginate.to = response.data.to
                this.statusList = true
            }).catch((error) => { this.$store.commit('throwException', error) })
        },
        excluir (id) {
            this.$msgbox.confirm('Tem certeza que deseja excluir este AEE/PAD?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' })
                .then(() => {
                    window.eventBus.$emit('loading', true)
                    this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/plano-aee/delete/` + id, this.$store.getters.getHeaderAuth)
                        .then(() => {
                            window.eventBus.$emit('loading', false)
                            window.eventBus.$emit('alert', { msg: 'AEE/PAD excluído com sucesso.', type: 'success' })
                            this.load()
                        }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
                }).catch(() => {})
        },
        imprimir (id) {
            window.eventBus.$emit('loading', true)
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/plano-aee/imprimir/${id}`,
                this.$store.getters.getHeaderAuthExcel
            ).then(response => {
                window.eventBus.$emit('loading', false)
                const blob = new Blob([response.data], { type: response.headers['content-type'] || 'application/pdf' })
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.target = '_blank'
                link.click()
                window.URL.revokeObjectURL(link.href)
            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
        },
        getPage (page) {
            this.paginate.page = page
            this.load()
        }
    }
}
</script>
